const isInIframe = () => window !== window.parent;

export { isInIframe };
